import {
  ImageList,
  ImageListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import React from 'react';


import HypothecationDetails from '../PlacementSlips/HypothecationDetails';
import PolicyCompareQcRemarks from './PolicyCompareQcRemarks';

function PlacementDetailInstallmentSection({ installmentDetails, placementSlipData, type = null, policyDetail = null, qcRemarkOfEachSections = null, checkAllModuleIsVerified = null, setQcRemarkOfEachSections = null }) {
  const getImageFilePreview = (image) => {
    if (image != '') {
      return `${image}?w=164&h=2000&objectFit=contain`;
    } else {
      return 'https://p.kindpng.com/picc/s/160-1608792_circle-document-icon-png-transparent-png.png';
    }
  };
  return (
    <>
      <div style={{ marginTop: '1%' }}>
        {type != 'qc' && <Typography variant="h6">* Rewards as applicable extra</Typography>}
        {placementSlipData?.hypothecationApplicable ? (
          <div>
            <HypothecationDetails
              hypothecations={placementSlipData.hypothecations}
              type={'qc'}
              policyDetail={policyDetail}
            />
            {type == 'qc' && <div
              style={
                type === 'qc'
                  ? {
                    opacity:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.hypothecation_details
                        ?.status === 'approve'
                        ? 0.5
                        : 1,
                    pointerEvents:
                      (
                        policyDetail?.parentqcData ||
                        policyDetail?.insurancePolicy?.qcData
                      )?.hypothecation_details
                        ?.status === 'approve'
                        ? 'none'
                        : 'auto',
                    marginBottom: '10px'
                  }
                  : { marginBottom: '10px' }
              }
            >
              <PolicyCompareQcRemarks
                modouleDetail={policyDetail}
                qcRemarkOfEachSections={qcRemarkOfEachSections}
                section_key={'hypothecation_details'}
                block_key={''}
                checkAllModuleIsVerified={
                  checkAllModuleIsVerified
                }
                setQcRemarkOfEachSections={setQcRemarkOfEachSections}
              />
            </div>}
          </div>) : null}

        <div

          style={
            type === 'qc'
              ? {
                opacity:
                  (
                    policyDetail?.parentqcData ||
                    policyDetail?.insurancePolicy?.qcData
                  )?.payment_details?.status === 'approve'
                    ? 0.5
                    : 1,
                pointerEvents:
                  (
                    policyDetail?.parentqcData ||
                    policyDetail?.insurancePolicy?.qcData
                  )?.payment_details?.status === 'approve'
                    ? 'none'
                    : 'auto',

              }
              : {}
          }
        >

          <Typography variant="h5">Payment Details</Typography>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ background: 'rgba(187, 220, 214, 0.32)' }}>
              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Transaction Ref
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Amount Paid
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Payment Date
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Bank
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  Branch
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.paymentType
                    ? installmentDetails?.[0]?.paymentType
                    : 'N/A'}
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.paymentReferenceNo
                    ? installmentDetails?.[0]?.paymentReferenceNo
                    : 'N/A'}
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.amountToBePaid
                    ? installmentDetails?.[0]?.amountToBePaid
                    : 'N/A'}
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.dueDate
                    ? moment(installmentDetails?.[0]?.dueDate).format(
                      'DD-MM-yyyy'
                    )
                    : 'N/A'}
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.bankName
                    ? installmentDetails?.[0]?.bankName
                    : 'N/A'}
                </TableCell>
                <TableCell
                  style={{
                    height: '20px',
                    paddingTop: '2px',
                    paddingBottom: '2px'
                  }}
                >
                  {installmentDetails?.[0]?.bankBranch
                    ? installmentDetails?.[0]?.bankBranch
                    : 'N/A'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {type == 'qc' && <div style={{ marginBottom: '10px' }}>
            <PolicyCompareQcRemarks
              modouleDetail={policyDetail}
              qcRemarkOfEachSections={qcRemarkOfEachSections}
              section_key={'payment_details'}
              block_key={''}
              checkAllModuleIsVerified={
                checkAllModuleIsVerified
              }
              setQcRemarkOfEachSections={setQcRemarkOfEachSections}
            />
          </div>}
        </div>


      </div>
      <div
        style={
          type === 'qc'
            ? {
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.installment_details
                  ?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.installment_details
                  ?.status === 'approve'
                  ? 'none'
                  : 'auto',
              marginTop: '1%'
            }
            : { marginTop: '1%' }
        }
      >
        <Typography variant="h5">Installment Details</Typography>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: 'rgba(187, 220, 214, 0.32)' }}>
            <TableRow>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px'
                }}
              >
                Installment No.
              </TableCell>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px'
                }}
              >
                Amount To Be Paid
              </TableCell>
              <TableCell
                style={{
                  height: '20px',
                  paddingTop: '2px',
                  paddingBottom: '2px'
                }}
              >
                Due Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {installmentDetails?.map((installment, index) => {
              return (
                <>
                  <TableRow>
                    <TableCell
                      style={{
                        height: '20px',
                        paddingTop: '2px',
                        paddingBottom: '2px'
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      style={{
                        height: '20px',
                        paddingTop: '2px',
                        paddingBottom: '2px'
                      }}
                    >
                      {installment.amountToBePaid
                        ? installment.amountToBePaid
                        : 'N/A'}
                    </TableCell>
                    <TableCell
                      style={{
                        height: '20px',
                        paddingTop: '2px',
                        paddingBottom: '2px'
                      }}
                    >
                      {installment.dueDate
                        ? moment(installment.dueDate).format('DD-MM-yyyy')
                        : 'N/A'}
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
        {type != 'qc' && <p style={{ color: 'red' }}>
          *GST Extra as applicable at the time of payment
        </p>}

        {type == 'qc' && <div style={{ marginBottom: '10px' }}>
          <PolicyCompareQcRemarks
            modouleDetail={policyDetail}
            qcRemarkOfEachSections={qcRemarkOfEachSections}
            section_key={'installment_details'}
            block_key={''}
            checkAllModuleIsVerified={
              checkAllModuleIsVerified
            }
            setQcRemarkOfEachSections={setQcRemarkOfEachSections}
          />
        </div>}

      </div>
    </>
  );
}

export default PlacementDetailInstallmentSection;
